<template>
  <div class="c-base-file" :class="[{ 'c-base-file--is-valid': state === true,  'c-base-file--is-invalid': state === false}]">
    <input :id="id" class="c-base-file__input" type="file" v-on="listeners" v-bind="$attrs" :multiple="isMultiplePicker">
    <label :for="id" class="c-base-file__label">
      <base-button tag="div" variant="outline-secondary" size="sm" is-pill :icon-prepend="['fal', 'paperclip']">{{ $t('label.attachments') }}</base-button>
      <template v-if="fileNames">
        <span class="c-base-file__label-title">{{ fileNames }}</span>
      </template>
      <template v-else>
        <span class="c-base-file__label-placeholder">{{ $t('sentence.fileSelectPlaceholder') }}</span>
      </template>
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseFileInput',

  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    value: {
      type: [File, Array],
      default: function () {
        return this.isMultiplePicker ? [] : null
      }
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    isMultiplePicker: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      localValue: this.value,
      id: `file-${Math.random().toString(36).substring(2, 10)}`
    }
  },

  mounted () {
    this.$watch(() => this.value, value => {
      if (this.localValue !== value) {
        this.localValue = value
      }
    })
  },

  computed: {
    listeners () {
      const { change, ...listeners } = this.$listeners
      return {
        change: event => this.onEvent(event, 'change'),
        ...listeners }
    },

    fileNames () {
      return this.localValue ? this.isMultiplePicker ? Array.from(this.localValue).map(item => item.name).join(', ') : this.localValue.name : null
    }
  },

  methods: {
    onUpdate (value) {
      if (this.localValue !== value) {
        this.localValue = value
      }

      this.$emit('update', value)
    },

    onEvent (event, name) {
      const value = this.isMultiplePicker ? Array.from(event.target.files) : event.target.files[0]

      this.onUpdate(value)
      this.$emit(name, value)
    }
  }
}
</script>
